import {
  AppWindow,
  BookOpen,
  Building2,
  CalendarDays,
  Home,
  Settings,
  UserRound,
  UsersRound,
  LifeBuoy,
} from "lucide-react";
import type { ComponentType } from "react";
import type { OrgUserRole } from "@/types/firestore";

export interface PortalNavItem {
  label: string;
  to: string;
  icon: ComponentType<{ className?: string }>;
}

const baseTopItems: PortalNavItem[] = [
  { label: "Dashboard", to: "/org", icon: Home },
  { label: "Workspaces", to: "/org/studios", icon: Building2 },
];

const baseBottomItems: PortalNavItem[] = [
  { label: "Resources", to: "/org/resources", icon: BookOpen },
  { label: "Users", to: "/org/users", icon: UserRound },
  { label: "Team", to: "/org/team", icon: UsersRound },
  { label: "Settings", to: "/org/settings", icon: Settings },
];

export function portalNavItems({
  hasApps,
  workshopsEnabled,
  supportEnabled = false,
}: {
  hasApps: boolean;
  workshopsEnabled: boolean;
  supportEnabled?: boolean;
}): PortalNavItem[] {
  return [
    ...baseTopItems,
    ...(supportEnabled ? [{ label: "Support", to: "/org/support", icon: LifeBuoy }] : []),
    ...(hasApps ? [{ label: "Apps", to: "/org/apps", icon: AppWindow }] : []),
    ...(workshopsEnabled
      ? [{ label: "Workshops", to: "/org/workshops", icon: CalendarDays }]
      : []),
    ...baseBottomItems,
  ];
}

export const portalRoleLabels: Partial<Record<OrgUserRole, string>> = {
  ORG_OWNER: "Organization Owner",
  ORG_ADMIN: "Organization Administrator",
};
